
document.addEventListener("DOMContentLoaded", function () {
    $('.banner-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000, // Adjust fade speed
        fade: false, // Enables fade transition
        cssEase: 'linear',
      prevArrow: '<button class="slick-prev" type="button">' +
               '<svg width="21" height="36" viewBox="0 0 21 36" fill="none" xmlns="http://www.w3.org/2000/svg">' +
               '<path d="M0.570176 19.2683L16.4773 35.175C16.8452 35.5432 17.3363 35.7461 17.86 35.7461C18.3836 35.7461 18.8748 35.5432 19.2427 35.175L20.4141 34.0039C21.1764 33.2408 21.1764 32.0004 20.4141 31.2385L7.05657 17.8809L20.429 4.50852C20.7969 4.14032 21 3.64948 21 3.12609C21 2.60213 20.7969 2.11129 20.429 1.74279L19.2575 0.57193C18.8893 0.203728 18.3985 0.000885264 17.8748 0.000885316C17.3511 0.000885367 16.86 0.203728 16.4921 0.57193L0.570176 16.4932C0.201394 16.8626 -0.00116048 17.3558 3.02803e-06 17.88C-0.00116043 18.4063 0.201394 18.8992 0.570176 19.2683Z" fill="#254A2E"/>' +
             '</svg></button>',
    nextArrow: '<button class="slick-next" type="button">' +
                '<svg width="21" height="36" viewBox="0 0 21 36" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M20.4298 16.4778L4.52275 0.571047C4.15484 0.202845 3.66371 -5.83053e-08 3.14003 -4.99714e-08C2.61635 -4.16374e-08 2.12522 0.202845 1.75731 0.571047L0.585868 1.7422C-0.1764 2.50534 -0.1764 3.74566 0.585868 4.50764L13.9434 17.8652L0.571046 31.2376C0.203135 31.6058 -6.84976e-07 32.0966 -6.96145e-07 32.62C-7.07327e-07 33.144 0.203135 33.6348 0.571046 34.0033L1.74249 35.1742C2.11069 35.5424 2.60153 35.7452 3.12521 35.7452C3.64889 35.7452 4.14002 35.5424 4.50793 35.1742L20.4298 19.2529C20.7986 18.8835 21.0012 18.3903 21 17.8661C21.0012 17.3398 20.7986 16.8469 20.4298 16.4778Z" fill="#254A2E"/>' +
               '</svg></button>',
    });

  // Custom testimonial slider
  $('.cust_testimonialSlide').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000, // Adjust fade speed
    fade: false, // Enables fade transition
    cssEase: 'linear',
    prevArrow: '<button class="slick-prev" type="button">' +
               '<svg width="21" height="36" viewBox="0 0 21 36" fill="none" xmlns="http://www.w3.org/2000/svg">' +
               '<path d="M0.570176 19.2683L16.4773 35.175C16.8452 35.5432 17.3363 35.7461 17.86 35.7461C18.3836 35.7461 18.8748 35.5432 19.2427 35.175L20.4141 34.0039C21.1764 33.2408 21.1764 32.0004 20.4141 31.2385L7.05657 17.8809L20.429 4.50852C20.7969 4.14032 21 3.64948 21 3.12609C21 2.60213 20.7969 2.11129 20.429 1.74279L19.2575 0.57193C18.8893 0.203728 18.3985 0.000885264 17.8748 0.000885316C17.3511 0.000885367 16.86 0.203728 16.4921 0.57193L0.570176 16.4932C0.201394 16.8626 -0.00116048 17.3558 3.02803e-06 17.88C-0.00116043 18.4063 0.201394 18.8992 0.570176 19.2683Z" fill="#254A2E"/>' +
               '</svg></button>',
    nextArrow: '<button class="slick-next" type="button">' +
               '<svg width="21" height="36" viewBox="0 0 21 36" fill="none" xmlns="http://www.w3.org/2000/svg">' +
               '<path d="M20.4298 16.4778L4.52275 0.571047C4.15484 0.202845 3.66371 -5.83053e-08 3.14003 -4.99714e-08C2.61635 -4.16374e-08 2.12522 0.202845 1.75731 0.571047L0.585868 1.7422C-0.1764 2.50534 -0.1764 3.74566 0.585868 4.50764L13.9434 17.8652L0.571046 31.2376C0.203135 31.6058 -6.84976e-07 32.0966 -6.96145e-07 32.62C-7.07327e-07 33.144 0.203135 33.6348 0.571046 34.0033L1.74249 35.1742C2.11069 35.5424 2.60153 35.7452 3.12521 35.7452C3.64889 35.7452 4.14002 35.5424 4.50793 35.1742L20.4298 19.2529C20.7986 18.8835 21.0012 18.3903 21 17.8661C21.0012 17.3398 20.7986 16.8469 20.4298 16.4778Z" fill="#254A2E"/>' +
               '</svg></button>',
    responsive: [
        {
        breakpoint: 750,
            settings: {
                arrows: false,
                dots: true
            }
        }
    ]
  });
  // Custom testimonial slider

  // Product testimonial slider
  $('.prod_testimonial_slide').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000, // Adjust fade speed
    fade: false, // Enables fade transition
    cssEase: 'linear',
    prevArrow: '<button class="slick-prev" type="button">' +
               '<svg width="21" height="36" viewBox="0 0 21 36" fill="none" xmlns="http://www.w3.org/2000/svg">' +
               '<path d="M0.570176 19.2683L16.4773 35.175C16.8452 35.5432 17.3363 35.7461 17.86 35.7461C18.3836 35.7461 18.8748 35.5432 19.2427 35.175L20.4141 34.0039C21.1764 33.2408 21.1764 32.0004 20.4141 31.2385L7.05657 17.8809L20.429 4.50852C20.7969 4.14032 21 3.64948 21 3.12609C21 2.60213 20.7969 2.11129 20.429 1.74279L19.2575 0.57193C18.8893 0.203728 18.3985 0.000885264 17.8748 0.000885316C17.3511 0.000885367 16.86 0.203728 16.4921 0.57193L0.570176 16.4932C0.201394 16.8626 -0.00116048 17.3558 3.02803e-06 17.88C-0.00116043 18.4063 0.201394 18.8992 0.570176 19.2683Z" fill="#254A2E"/>' +
               '</svg></button>',
    nextArrow: '<button class="slick-next" type="button">' +
               '<svg width="21" height="36" viewBox="0 0 21 36" fill="none" xmlns="http://www.w3.org/2000/svg">' +
               '<path d="M20.4298 16.4778L4.52275 0.571047C4.15484 0.202845 3.66371 -5.83053e-08 3.14003 -4.99714e-08C2.61635 -4.16374e-08 2.12522 0.202845 1.75731 0.571047L0.585868 1.7422C-0.1764 2.50534 -0.1764 3.74566 0.585868 4.50764L13.9434 17.8652L0.571046 31.2376C0.203135 31.6058 -6.84976e-07 32.0966 -6.96145e-07 32.62C-7.07327e-07 33.144 0.203135 33.6348 0.571046 34.0033L1.74249 35.1742C2.11069 35.5424 2.60153 35.7452 3.12521 35.7452C3.64889 35.7452 4.14002 35.5424 4.50793 35.1742L20.4298 19.2529C20.7986 18.8835 21.0012 18.3903 21 17.8661C21.0012 17.3398 20.7986 16.8469 20.4298 16.4778Z" fill="#254A2E"/>' +
               '</svg></button>',
    responsive: [
        {
        breakpoint: 750,
            settings: {
                arrows: false,
                dots: true
            }
        }
    ]
  });
  // Product testimonial slider

  // Image slider on Course page
  $('.img_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 1000, // Adjust fade speed
    fade: false, // Enables fade transition
    cssEase: 'linear'
  });
  // Image slider on Course page

  // Smooth scrioll to the section
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href").slice(1);
      const target = document.getElementById(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: "smooth" });
      }
    });
  });
  // Smooth scrioll to the section
  
});


var slickdots=($('.index-banner .index-banner-wrap .index-banner-inner .item').length);
if (slickdots <= 1) {
$(".index-banner .index-banner-wrap").addClass("is-dots-hide");
}
	 


// function indexBestSellerAndrelatedPro() {
// $('.trending-product-slider').slick({
//   dots: false,
//   arrows: true,
//   infinite: true,
//   speed: 300,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   prevArrow: $('.best-left-arrow'),
//   nextArrow: $('.best-right-arrow'),
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         infinite: true,
//         dots: false
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//          dots: true,
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// });
// }

// //calling function
// indexBestSellerAndrelatedPro(); 



// $('.testimonials-slider').slick({
//   dots: false,
//   arrows: true,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 2.5,
//   slidesToScroll: 1,
//   prevArrow: $('.testiLeftArrow'),
//   nextArrow: $('.testiRightArrow'),
//   responsive: [
//     {
//       breakpoint: 1200,
//       settings: {
//         slidesToShow: 2.1
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 1.2
//       }
//     }
//   ]
// });



// $(document).ready(function () {
//     $(".cmn-tab").click(function () {
//         $(this).addClass("active").siblings().removeClass("active");

//         let tabId = $(this).attr("data-id");

//         $(this).closest(".titl-tab-wrap").next(".tab-menu").children().each(function () {
//             let TabcontId = $(this).attr("data-id");
//             if (tabId === TabcontId) {
//                 $(this).show().addClass("active").siblings().hide().removeClass("active");                

//                 let DataLink = this.getAttribute("data-link");
//                 document.querySelector(".coll-tab-link").setAttribute("href", DataLink);
//             }
//         });
//       $('.tab-pro-slider').slick('refresh');
      

      
//     });
// });

// $('.tab-pro-slider').slick({
//   dots: true,
//   arrows: true,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   prevArrow: '<button class="slick-prev" type="button">' +
//              '<svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
//              '<path d="M0.46967 5.46967C0.176777 5.76256 0.176777 6.23744 0.46967 6.53033L5.24264 11.3033C5.53553 11.5962 6.01041 11.5962 6.3033 11.3033C6.59619 11.0104 6.59619 10.5355 6.3033 10.2426L2.06066 6L6.3033 1.75736C6.59619 1.46447 6.59619 0.989593 6.3033 0.696699C6.01041 0.403806 5.53553 0.403806 5.24264 0.696699L0.46967 5.46967ZM17 6.75C17.4142 6.75 17.75 6.41421 17.75 6C17.75 5.58579 17.4142 5.25 17 5.25V6.75ZM1 6.75H17V5.25H1V6.75Z" fill="#547F62"/>' +
//              '</svg></button>',
//   nextArrow: '<button class="slick-next" type="button">' +
//              '<svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
//              '<path d="M1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75V5.25ZM17.5303 6.53033C17.8232 6.23744 17.8232 5.76256 17.5303 5.46967L12.7574 0.696699C12.4645 0.403806 11.9896 0.403806 11.6967 0.696699C11.4038 0.989593 11.4038 1.46447 11.6967 1.75736L15.9393 6L11.6967 10.2426C11.4038 10.5355 11.4038 11.0104 11.6967 11.3033C11.9896 11.5962 12.4645 11.5962 12.7574 11.3033L17.5303 6.53033ZM1 6.75H17V5.25H1V6.75Z" fill="#EBCE4B"/>' +
//              '</svg></button>',
  
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         infinite: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// });



// $('.center-slider').slick({
//     slidesToShow: 5,
//     slidesToScroll: 1,
//     centerMode: true,
//     arrows: true,
//     dots: false,
//     speed: 300,
//     infinite: true,
//     autoplaySpeed: 5000,
//     autoplay: false,
//     prevArrow: '<button class="slick-prev" type="button">' +
//                '<svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
//                '<path d="M0.46967 5.46967C0.176777 5.76256 0.176777 6.23744 0.46967 6.53033L5.24264 11.3033C5.53553 11.5962 6.01041 11.5962 6.3033 11.3033C6.59619 11.0104 6.59619 10.5355 6.3033 10.2426L2.06066 6L6.3033 1.75736C6.59619 1.46447 6.59619 0.989593 6.3033 0.696699C6.01041 0.403806 5.53553 0.403806 5.24264 0.696699L0.46967 5.46967ZM17 6.75C17.4142 6.75 17.75 6.41421 17.75 6C17.75 5.58579 17.4142 5.25 17 5.25V6.75ZM1 6.75H17V5.25H1V6.75Z" fill="#547F62"/>' +
//                '</svg></button>',
//     nextArrow: '<button class="slick-next" type="button">' +
//                '<svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
//                '<path d="M1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75V5.25ZM17.5303 6.53033C17.8232 6.23744 17.8232 5.76256 17.5303 5.46967L12.7574 0.696699C12.4645 0.403806 11.9896 0.403806 11.6967 0.696699C11.4038 0.989593 11.4038 1.46447 11.6967 1.75736L15.9393 6L11.6967 10.2426C11.4038 10.5355 11.4038 11.0104 11.6967 11.3033C11.9896 11.5962 12.4645 11.5962 12.7574 11.3033L17.5303 6.53033ZM1 6.75H17V5.25H1V6.75Z" fill="#EBCE4B"/>' +
//                '</svg></button>',
//     responsive: [
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 3
//       }
//     }
//   ]
  

// });



// $(document).on("click",".filter--menu--box .filter-label",function() {
// $(this).next().slideToggle();
// $(this).parent().toggleClass("is--open");
// });
// if($(window).innerWidth() >= 768) {
// $(".filter--menu--box .filter-label" ).first().trigger( "click" );
// }
// $(document).on("click",".filter--menu---drawer--icons",function() {
// $(".facets-wrapper").slideToggle();
// $(this).parent().toggleClass("is--select");
// });

$(".template-collection .inner-banner .cmn-heading").html(function(){
  var text= $(this).text().trim().split(" ");
  var last = text.pop();
  return text.join(" ") + (text.length > 0 ? " <span class='color--light'>" + last + "</span>" : last);
});
$(document).on("click",".pre-order-btn",function() {
  $(this).fadeOut();
  $(".pre-order-form").fadeIn();
  $(".widget-wrap .newsletter-form__message").fadeOut();
});








// partner logo section
// $('.announce-marquee').slick({
//   speed: 3000,
//   autoplay: true,
//   autoplaySpeed: 0,
//   centerMode: true,
//   cssEase: 'linear',
//   slidesToShow: 5,
//   slidesToScroll: 1,
//   variableWidth: true,
//   infinite: true,
//   arrows: false,
//   dots: false
// });
document.addEventListener("DOMContentLoaded", function () {
  const marquee = document.querySelector(".announce-marquee");
  if (!marquee) return;

  const itemCount = marquee.querySelectorAll(".item").length;
  const screenWidth = window.innerWidth;

  const shouldInitSlider =
    (screenWidth >= 750 && itemCount >= 6) ||
    (screenWidth < 750 && itemCount > 2);

  if (shouldInitSlider) {
    $(marquee).slick({
      speed: 8000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: "linear",
      slidesToShow: 5,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            variableWidth: true
          }
        }
      ]
    });
  }
});



// Custom text slider
  document.addEventListener("DOMContentLoaded", function () {
    const textMarquee = document.querySelector(".textSlide_marquee");
    if (!textMarquee) return;
  
    const text_itemCount = textMarquee.querySelectorAll(".item").length;
    const text_screenWidth = window.innerWidth;
  
    const text_shouldInitSlider =
      (text_screenWidth >= 750 && text_itemCount >= 6) ||
      (text_screenWidth < 750 && text_itemCount > 3);
  
    if (text_shouldInitSlider) {
      $(textMarquee).slick({
        speed: 8000,
        autoplay: true,
        autoplaySpeed: 0,
        pauseOnHover: false,
        centerMode: true,
        cssEase: "linear",
        slidesToShow: 5,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        arrows: false,
        dots: false,
        responsive: [
          {
            breakpoint: 749,
            settings: {
              slidesToShow: 3,
              centerMode: false,
              variableWidth: true
            }
          }
        ]
      });
    }
  });
// Custom text slider

    

 // faq page script
$(".faq-heading").click(function () {
  $(this).parent(".faq-block-items").toggleClass("active");
  $(this).next(".faq-text").slideToggle();
   $(this).parent(".faq-block-items").siblings().removeClass("active");
   $(this).parent(".faq-block-items").siblings().find(".faq-text").slideUp();
});   

$(function() {
  $(".faq-grid").slice(0, 10).show(); // select the first ten
  $("#load").hide();
  if ($(".faq-grid").length > 10) { 
      $("#load").show();
    }
  $("#load").click(function(e) { // click event for load more
    e.preventDefault();
    $(".faq-grid:hidden").slice(0, 5).show(); // select next 10 hidden divs and show them
    if ($(".faq-grid:hidden").length == 0) { // check if any hidden divs still exist
      $("#load").hide();
    }
  });
}); 





// tab in the Tool to support page
document.addEventListener("DOMContentLoaded" , function() {

   document.querySelectorAll(".cmn-tab").forEach(function (item){
      item.addEventListener("click", function(){

        // active class add and remove
        const tabId = this.getAttribute("data-id");
        this.classList.toggle("active");

         const TabParent = Array.from(this.parentElement.children);
          TabParent.forEach(function (sibling) {
            if(sibling != this){
            sibling.classList.remove("active");
            }
          }, this);


        // bottom process

          const nextSibling = Array.from(this.parentElement.nextElementSibling.children);
           nextSibling.forEach(function (infoItem){
                const InfoId = infoItem.getAttribute("data-id");
                if(InfoId == tabId){
                    infoItem.style.display = "block";
                    infoItem.classList.add("active");

                    const infoParent = Array.from(infoItem.parentElement.children);
                     infoParent.forEach(function (infoparentitem){
                        if(infoparentitem != infoItem){
                            infoparentitem.style.display = "none";
                            infoparentitem.classList.remove("active");
                        }
                     });
                 }                             
           });     
      });
   });   
 });



// popup script in the Tool to support page
document.querySelectorAll(".support-learnm-btn").forEach(function (item) {
  item.addEventListener("click", function () {
     this.parentElement.parentElement.classList.toggle("popup-active");
     document.body.classList.toggle("support-popup-open");
    // alert("click");
  });
});
document.querySelectorAll(".support-close-btn").forEach(function (item) {
  item.addEventListener("click", function () {
     this.parentElement.parentElement.parentElement.classList.toggle("popup-active");
     document.body.classList.toggle("support-popup-open");
    // alert("click");
  });
});
document.querySelectorAll(".popoverlay").forEach(function (item) {
  item.addEventListener("click", function () {
     this.parentElement.parentElement.classList.toggle("popup-active");
     document.body.classList.toggle("support-popup-open");
    // alert("click");
  });
});




// Pagination script for Tool to Support page
jQuery(document).ready(function () {
  var show_per_page = 9; 
  var number_of_items = $('#pagingBox').children().length;
  var number_of_pages = Math.ceil(number_of_items / show_per_page);

  $('#current_page').val(0);
  $('#show_per_page').val(show_per_page);


  var navigation_html = '<span class="previous_link disabled">Prev</span>';
  var current_link = 0;
  while (number_of_pages > current_link) {
    navigation_html += '<span class="page_link" data-page="' + current_link + '">' + (current_link + 1) + '</span>';
    current_link++;
  }
  navigation_html += '<span class="next_link">Next</span>';

  $('#page_navigation').html(navigation_html);

  $('#page_navigation .page_link:first').addClass('active_page');

  $('#pagingBox').children().hide();
  $('#pagingBox').children().slice(0, show_per_page).show();

  // Attach click handlers
  $('.page_link').click(function () {
  var page_num = $(this).data('page');
  go_to_page(page_num);
  });

$('.previous_link').click(function () {
  previous();
});

$('.next_link').click(function () {
  next();
});

  
});

function previous() {
  var new_page = parseInt($('#current_page').val()) - 1;
  if (new_page >= 0) {
    go_to_page(new_page);
  }
}

function next() {
  var new_page = parseInt($('#current_page').val()) + 1;
  var max_page = Math.ceil($('#pagingBox').children().length / parseInt($('#show_per_page').val())) - 1;
  if (new_page <= max_page) {
    go_to_page(new_page);
  }
}

function go_to_page(page_num) {
  var show_per_page = parseInt($('#show_per_page').val());
  var start_from = page_num * show_per_page;
  var end_on = start_from + show_per_page;
   var number_of_items = $('#pagingBox').children().length;
  var number_of_pages = Math.ceil(number_of_items / show_per_page);

  $('#pagingBox').children().hide().slice(start_from, end_on).show();

  $('.page_link').removeClass('active_page');
  $('.page_link[data-page=' + page_num + ']').addClass('active_page');

  $('#current_page').val(page_num);



  // Manage disabled class for Prev/Next
  if (page_num === 0) {
    $('.previous_link').addClass('disabled');
  } else {
    $('.previous_link').removeClass('disabled');
  }

  if (page_num === number_of_pages - 1) {
    $('.next_link').addClass('disabled');
  } else {
    $('.next_link').removeClass('disabled');
  }
}



$('#page_navigation').on('click', '.page_link', function () {
   setTimeout(function() {
    if (!$(this).hasClass('active_page') && !$(this).hasClass('disabled')) {
        
        // Scroll to top
        $('html, body').animate({ scrollTop: 0 }, 300);
    }
       }, 1000);
});


if($(window).innerWidth() <= 599) {
$(".Tool-to-Support-tab-wrap .Tool-to-Support-tab-inner .tab-main .tab-menu .cmn-tab ").click(function() {
	$('.msg-list-text-show').html(($(this).text()));
	$('.Tool-to-Support-tab-wrap .Tool-to-Support-tab-inner .tab-main .tab-menu').fadeOut();
});
$('.msg-list-text-show').on('click', function(e) {
      $(this).next().toggleClass("vale-show").slideToggle();
      e.preventDefault();
    });
}

if($(window).innerWidth() <= 599) {
$(".collection--main--wrap .filter-info ul li a").click(function() {
	$('.filter--menu---drawer').html(($(this).text()));
	$('.collection--main--wrap .filter-info .list-unstyled').fadeOut();
});
$('.filter--menu---drawer').on('click', function(e) {
      $(this).next().toggleClass("vale-show").slideToggle();
      e.preventDefault();
    });
}




// mobile best seller script
 document.addEventListener("DOMContentLoaded", function () {
    const groups = document.querySelectorAll(".product-page-group");
    const prevBtn = document.getElementById("prevPage");
    const nextBtn = document.getElementById("nextPage");
    const pageInfo = document.getElementById("paginationInfo");

    let current = 1;
    const total = groups.length;

    function updateView() {
      groups.forEach((group, i) => {
        group.style.display = (i === current - 1) ? "block" : "none";
      });

      if(pageInfo) pageInfo.textContent = `Page ${current} of ${total}`;
      if(prevBtn) prevBtn.disabled = current === 1;
      if(nextBtn) nextBtn.disabled = current === total;
    }

    prevBtn?.addEventListener("click", () => {
      if (current > 1) {
        current--;
        updateView();
      }
    });

    nextBtn?.addEventListener("click", () => {
      if (current < total) {
        current++;
        updateView();
      }
    });

    updateView(); // Initialize on load
  });





// collection page
$(document).ready(function() {
  setTimeout(function() {
    var activeItem = $('.mobile-coll-block__details-content .list-menu__item--active').text().trim();
    $('.filter--menu---drawer').text(activeItem);
    console.log('Active item:', activeItem);
  }, 1500); 
});



// home page slider class for glitch issue
setTimeout(function() {
  const banner = document.querySelector('.index-baner-main');
  if (banner && banner.classList.contains('banner-opacity')) {
    banner.classList.remove('banner-opacity');
  }
}, 200);


// Testimonial silder on Health & Wellness page
document.addEventListener("DOMContentLoaded", function () {
  $('.testimonial_slide').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000,
    // speed: 1000, // Adjust fade speed
    // fade: false, // Enables fade transition
    cssEase: 'linear',
    centerMode: true,
    prevArrow: '<button class="slick-prev" type="button">' +
               '<svg width="21" height="36" viewBox="0 0 21 36" fill="none" xmlns="http://www.w3.org/2000/svg">' +
               '<path d="M0.570176 19.2683L16.4773 35.175C16.8452 35.5432 17.3363 35.7461 17.86 35.7461C18.3836 35.7461 18.8748 35.5432 19.2427 35.175L20.4141 34.0039C21.1764 33.2408 21.1764 32.0004 20.4141 31.2385L7.05657 17.8809L20.429 4.50852C20.7969 4.14032 21 3.64948 21 3.12609C21 2.60213 20.7969 2.11129 20.429 1.74279L19.2575 0.57193C18.8893 0.203728 18.3985 0.000885264 17.8748 0.000885316C17.3511 0.000885367 16.86 0.203728 16.4921 0.57193L0.570176 16.4932C0.201394 16.8626 -0.00116048 17.3558 3.02803e-06 17.88C-0.00116043 18.4063 0.201394 18.8992 0.570176 19.2683Z" fill="#254A2E"/>' +
             '</svg></button>',
    nextArrow: '<button class="slick-next" type="button">' +
                '<svg width="21" height="36" viewBox="0 0 21 36" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M20.4298 16.4778L4.52275 0.571047C4.15484 0.202845 3.66371 -5.83053e-08 3.14003 -4.99714e-08C2.61635 -4.16374e-08 2.12522 0.202845 1.75731 0.571047L0.585868 1.7422C-0.1764 2.50534 -0.1764 3.74566 0.585868 4.50764L13.9434 17.8652L0.571046 31.2376C0.203135 31.6058 -6.84976e-07 32.0966 -6.96145e-07 32.62C-7.07327e-07 33.144 0.203135 33.6348 0.571046 34.0033L1.74249 35.1742C2.11069 35.5424 2.60153 35.7452 3.12521 35.7452C3.64889 35.7452 4.14002 35.5424 4.50793 35.1742L20.4298 19.2529C20.7986 18.8835 21.0012 18.3903 21 17.8661C21.0012 17.3398 20.7986 16.8469 20.4298 16.4778Z" fill="#254A2E"/>' +
               '</svg></button>',
    responsive: [
      {
        breakpoint: 1601,
        settings: {
          slidesToShow: 1,
          centerPadding: '52rem'
        }
      },
      {
        breakpoint: 1449,
        settings: {
          slidesToShow: 1,
          centerPadding: '42rem'
        }
      },
      {
        breakpoint: 1370,
        settings: {
          slidesToShow: 1,
          centerPadding: '38rem'
        }
      },
      {
        breakpoint: 1299,
        settings: {
          slidesToShow: 1,
          centerPadding: '34rem'
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
          centerPadding: '21rem'
        }
      },
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 1,
          centerPadding: '9rem'
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerPadding: '0rem'
        }
      }
    ]
  });
});
// Testimonial silder on Health & Wellness page





// header menu link open in new window
document.addEventListener("DOMContentLoaded", function () {
    const links = document.querySelectorAll(".cus-header-menu");
    links.forEach(function(link) {
      if (link.href.includes("?new_window")) {
        link.setAttribute("target", "_blank");
      }
    });
  });


// product tik tok video section js
 function playVideo(index) {
    const thumbnail = document.querySelector(`[data-video-index="${index}"] .video-thumbnail`);
    const player = document.querySelector(`#video-player-${index}`);
    
    if (thumbnail && player) {
      thumbnail.style.display = 'none';
      player.style.display = 'block';
      
      // Auto-play video if it's a direct video file
      const video = player.querySelector('video, .cust_video');
      if (video) {
        video.play();
      }
    }
  }
  function closeVideo(index) {
    const thumbnail = document.querySelector(`[data-video-index="${index}"] .video-thumbnail`);
    const player = document.querySelector(`#video-player-${index}`);
    
    if (thumbnail && player) {
      player.style.display = 'none';
      thumbnail.style.display = 'block';
      
      // Pause video if it's a direct video file
      const video = player.querySelector('video, .cust_video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    }
  }
// product tik tok video section js END





